import React, {
  useContext,
  useCallback,
  useEffect,
  useRef,
  useState
} from "react";
import {NotificationManager} from "react-notifications";
import {invalid, valid} from "./utils/common";
import { getBoundingClientRect } from "./utils/dom";

export const runtime = (function(){
  let runtime = {};

  function initRuntime(){
    let userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf(" electron/") > -1) {
      runtime.electron = true;
    } else {
      const params = new URLSearchParams(window.location.search);
      runtime.mobile =
        params.has("device-mobile") ||
        /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);
      runtime.pc = !runtime.mobile;
    }
  }

  initRuntime();

  return runtime;
})();

//底层提供的JSON对时间的支持不太好，所以要用自定义的
export function parseJSON(code){
  if (!code) return;
  let obj = null;
  eval("obj=" + code + ";");
  return obj;
}

export function stringifyJSON(obj){
  return JSON.stringify(obj);
}

// export const getConfig = (function(){

//   let config = null;

//   function getConfig(path,defaultValue){
//     if(!config) return defaultValue;
//     let value = null;
//     try{
//       eval(`value=config.${path};`);
//     }
//     catch{
//       value = defaultValue;
//     }
//     if(Util.empty(value)) return defaultValue;
//     return Util.empty(value)?defaultValue : value;
//   }

//   return getConfig;

// })();

export function Config(props){
  this.set = props => {
    for (let e in props) {
      this[e] = props[e];
    }
  };

  if (props) this.set(props);
}

export class Storage {
  static get(name, defaultValue) {
    let key = Storage.getKey(name);
    let code = localStorage.getItem(key);
    return code ? JSON.parse(code) : defaultValue;
  }

  static set(name, value) {
    let key = Storage.getKey(name);
    let code = JSON.stringify(value);
    localStorage.setItem(key, code);
  }

  static remove(name) {
    let key = Storage.getKey(name);
    localStorage.removeItem(key);
  }

  static removes(func) {
    //要删除的返回true
    Storage.filter(key => {
      return func(key);
    }).forEach(key => {
      localStorage.removeItem(key);
    });
  }

  static getKey(name) {
    return `${name}-v${Storage.version || "1.0"}`;
  }

  static filter(func) {
    //保留的返回true
    let key;
    let l = [];
    for (let i = 0; (key = localStorage.key(i)); i++) {
      if (func(key)) {
        l.push(key);
      }
    }
    return l;
  }

  static exist(name) {
    let key = Storage.getKey(name);
    let current;
    for (let i = 0; (current = localStorage.key(i)); i++) {
      if (key === current) return true;
    }
    return false;
  }
}

export function useFetchState(...props){
  const focus = useRef();
  const [ state, setState ] = useState(...props);
  useEffect(() => {
    focus.current = true;
    return () => (focus.current = false);
  }, []);
  const setFetchState = useCallback((...params) => {
    focus.current && setState(...params);
  }, []);
  return [ state, setFetchState ];
}


//该方法非常适合用于由于非渲染进程绑定的事件,state丢失值的情况
export function useStateRef(value){
  const ref = useRef();
  const life = useRef();

  const [ state, setState ] = useState(value);
  const setStateRef = useCallback((v) => {
    if(life.current===false) return;
    ref.current = v;
    setState(v);
  }, []);

  useEffect(() => {
    ref.current = value;
    return ()=>{
      life.current=false;
    }
  }, []);

  return [ state, setStateRef,ref];
}

export function useStateAsync(value){
  const life = useRef();
  const [ state, setState ] = useState(value);
  const setStateAsync = useCallback((v) => {
    if(life.current===false) return;
    setState(v);
  }, []);

  useEffect(() => {
    return ()=>{
      life.current=false;
    }
  }, []);

  return [ state, setStateAsync];
}

// //计算引用所指的dom的大小
// export function useClientRect() {
//   const [rect, setRect] = useState(null);
//   const ref = useCallback(node => {
//     if (node !== null) {
//       setRect(node.getBoundingClientRect());
//     }
//   }, []);
//   return [rect, ref];
// }

//计算引用所指的dom的大小，使用该方法可以捕获到dom变化时，相关数据同步更新
export function useClientRect() {
  const [rect, setRect] = useState(null);
  const handleChange = useRef();
  // const nodeRef = useRef();

  const observer = new ResizeObserver(_.debounce(entries => {
    if(entries.length===0) return;
    let e = entries[0];
    //let rect = e.contentRect; 这个数据得不到x,y
    let rect = getBoundingClientRect(e.target);
    setRect(rect);

    let hc = handleChange.current;
    if(hc) hc(rect,e);
  }),200);
  
  const ref = useCallback(node => {
    if (node !== null) {
      observer.unobserve(node);
      observer.observe(node);
      // nodeRef.current = node;
    }
  }, []);

  const onChange = useCallback(handle => {
    handleChange.current = handle;
  }, []);

  // const refresh = useCallback(() => {
  //   let rect = getBoundingClientRect(nodeRef.current);
  //   setRect(rect);
  //   let hc = handleChange.current;
  //   if(hc) hc(rect,e);
  // }, []);

  useEffect(() => {
    
    return ()=>{
      observer.disconnect();
    }
  }, []);

  return [rect, ref,onChange];  //refresh重新计算
}

export function useClientRectGetter() {
  const nodeRef = useRef();

  const ref = useCallback(node => {
    if (node !== null) {
      nodeRef.current = node;
    }
  }, []);

  const get = useCallback(()=>{
    let c = nodeRef.current;
    if(!c) return;
    return getBoundingClientRect(c);
  },[]);

  return [get,ref];  //refresh重新计算
}

export function useSimpleRef(initialValue){ //这个方法让使用引用的代码变得简洁
  const ref = useRef();
  if(valid(initialValue)) ref.current=initialValue;

  const get = ()=>{
    return ref.current;
  }

  const set = (value)=>{
    ref.current = value;
  }

  return [ get,set, ref];
}